module.exports = __webpack_public_path__ + "static/media/zoomOut.293d9af8.svg";